<div class="search">
  <mat-form-field appearance="outline">
    <input
      [(ngModel)]="searchTerm"
      matInput
      placeholder="Pesquisar"
      (keyup)="applyFilter()"
    />
    <mat-icon class="icon-search" matSuffix>search</mat-icon>
  </mat-form-field>
</div>

<div class="container">
  <section *ngFor="let order of displayedItems">
    <ng-template #bottomSheetContent>
      <app-order-payment [order]="order?.id"></app-order-payment>
    </ng-template>

    <ng-template #bottomSheetContentBankAccount>
      <app-select-bank-account [order]="order"></app-select-bank-account>
    </ng-template>

    <ng-template #bottomSheetContentPayment>
      <app-order-payment-inbound [order]="order"></app-order-payment-inbound>
    </ng-template>

    <ng-template #bottomSheetContentUpdateOrder>
      <app-update-order [order]="order"></app-update-order>
    </ng-template>

    <div class="row row-content mt-4">
      <div class="col-6 mb-3">
        <p class="title">Nº da Ordem</p>
        <p class="description link">{{ order.id }}</p>
      </div>
      <div class="col-6 mb-3">
        <p class="title">Data de criação</p>
        <p class="description">
          {{ order.createdDate | date : "dd/MM/yyyy" }}
        </p>
      </div>

      <div class="col-6 mb-3">
        <p *ngIf="order.remmitanceType == 'OUTBOUND'" class="title">
          Valor de destino
        </p>
        <p *ngIf="order.remmitanceType == 'INBOUND'" class="title">
          Valor recebido
        </p>
        <p class="description">
          <span class="title"> {{ order.currency.description }} </span>
          {{ order.amount }}
        </p>
      </div>

      <div class="col-6 mb-3">
        <p class="title">Status</p>

        <p class="description" *ngIf="order?.statusFlow == 'PROCESSING'">
          Em análise
        </p>

        <p
          class="description"
          *ngIf="order?.statusFlow == 'PENDING_INVOICE_ATTACHMENT'"
        >
          Ordem criada
        </p>

        <p
          class="description"
          *ngIf="order?.statusFlow == 'REPROVED_WITH_CORRECTION'"
        >
          Reprovada
        </p>
        <p
          class="description"
          *ngIf="order?.statusFlow == 'AVAILABLE_QUOTATION'"
        >
          Aguardando cotação
        </p>
        <p
          class="description"
          *ngIf="
            order?.statusFlow == 'AVAILABLE_PAYMENT' &&
            order?.remmitanceType == 'OUTBOUND'
          "
        >
          Aguardando efetivação
        </p>
        <p class="description" *ngIf="order?.statusFlow == 'CANCELED'">
          Cancelada
        </p>

        <p
          class="description"
          *ngIf="order?.statusFlow == 'IDENTIFYING_PAYMENT' && order?.remmitanceType == 'OUTBOUND'"
        >
          Aguardando efetivação
        </p>

        <p
          class="description"
          *ngIf="order?.statusFlow == 'IDENTIFYING_PAYMENT' && order?.remmitanceType == 'INBOUND'"
        >
          Identificando pagamento
        </p>

        <p
          class="description"
          *ngIf="order?.statusFlow == 'IDENTIFIED_PAYMENT'"
        >
          Pagamento identificado
        </p>

        <p
          class="description"
          *ngIf="order?.statusFlow == 'IDENTIFYING_PAYMENT_ABROAD'"
        >
          Aguardando pagamento no exterior
        </p>

        <span
          class="description"
          *ngIf="
            order?.statusFlow == 'IDENTIFIED_PAYMENT_ABROAD' ||
            order?.statusFlow == 'PENDING_PAYMENT_INFORMATION'
          "
          ><img
            class="pr-2"
            src="assets/image/information-icon-red.svg"
          />Pendente informações</span
        >

        <p
          class="description"
          *ngIf="
            order?.statusFlow == 'AVAILABLE_PAYMENT' &&
            order?.remmitanceType == 'INBOUND'
          "
        >
          Fechamento concluído
        </p>

        <p class="description" *ngIf="order?.statusFlow == 'PAID'">Liquidada</p>
      </div>

      <div *ngIf="order.remmitanceType == 'INBOUND'" class="col-6">
        <p class="title">Nome do pagador</p>
        <p class="description">{{ order.sender.companyName }}</p>
      </div>

      <div *ngIf="order.remmitanceType == 'OUTBOUND'" class="col-6">
        <p class="title">Nome do beneficiário</p>
        <p class="description">{{ order.receiver.name }}</p>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-4 btn-action">
      <!-- <p class="description" *ngIf='order?.statusFlow == "PROCESSING" || order?.statusFlow == "CANCELED" || order?.statusFlow == "IDENTIFYING_PAYMENT" || order?.statusFlow == "IDENTIFIED_PAYMENT" || order?.statusFlow == "PAID"'>-</p>
      <p class="description" *ngIf='order?.statusFlow == "AVAILABLE_PAYMENT" && order?.remmitanceType == "INBOUND"'>-</p> -->
      <p
        class="tappable label-action"
        (click)="openQuotationModal(order)"
        *ngIf="order?.statusFlow == 'AVAILABLE_QUOTATION'"
      >
        Cotar
      </p>

      <p
        class="tappable label-action"
        *ngIf="
          order.statusFlow == 'PAID' &&
          (order?.orderSettlement?.exchangeContractFile ||
            order?.orderSettlement?.proofOperationFile)
        "
        (click)="downloadAttachment(order)"
      >
        Baixar
      </p>

      <p
        class="tappable label-action"
        *ngIf="order?.statusFlow == 'IDENTIFYING_PAYMENT_ABROAD'"
        (click)="openBottomSheetBankAccount()"
      >
        Consultar
      </p>

      <p
        class="tappable label-action"
        *ngIf="order?.statusFlow == 'IDENTIFIED_PAYMENT_ABROAD'"
        (click)="openUpdateOrderModal(order)"
      >
        Informar
      </p>

      <p
        class="tappable label-action"
        *ngIf="order?.statusFlow == 'PENDING_PAYMENT_INFORMATION'"
        (click)="openPaymentInboundModal(order)"
      >
        Informar
      </p>

      <p
        class="tappable label-action"
        (click)="openOrderPaymentModal(order)"
        *ngIf="
          order?.statusFlow == 'AVAILABLE_PAYMENT' &&
          order?.remmitanceType == 'OUTBOUND'
        "
      >
        Pagar
      </p>

      <p
        class="tappable"
        *ngIf="order?.statusFlow == 'REPROVED_WITH_CORRECTION'"
        (click)="openAttachInvoiceModal(order)"
      >
        Corrigir
      </p>
    </div>
  </section>

  <div class="d-flex justify-content-center mt-1">
    <mat-paginator
      (page)="changePage($event)"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="pageSizeOptions"
      [pageSize]="pageSize"
      [length]="filteredItems.length"
    ></mat-paginator>
  </div>
</div>
